export const INLINE_CODE = '.yfm-clipboard-inline-code';

export const OPEN_CLASS = 'open';
